import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { ArBreadcrumb } from "../components/ArBreadcrumb";
import { ArExplainer } from "../components/ArExplainer";
import { AspectRatioTool } from "../components/AspectRatioTool";

export function AspectRatioPage() {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-0 gradient-mesh" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <ArBreadcrumb />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.ar_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.ar_intro()}
          </p>
        </header>

        <AspectRatioTool />

        <ArExplainer
          howTo={m.ar_howto()}
          faqs={[
            { q: m.ar_faq1_q(), a: m.ar_faq1_a() },
            { q: m.ar_faq2_q(), a: m.ar_faq2_a() },
            { q: m.ar_faq3_q(), a: m.ar_faq3_a() },
            { q: m.ar_faq4_q(), a: m.ar_faq4_a() },
          ]}
        />

        <AdPlacement className="mt-10" />
      </div>
    </div>
  );
}
